<!-- Modal overlay that covers the full page. data-lenis-prevent allows native scroll inside. -->
<div
  *ngIf="isOpen"
  class="fixed inset-0 bg-black-50 dark:bg-black-70 backdrop-blur-sm z-[60] flex items-center justify-center py-6 px-4 sm:p-4 transition-opacity duration-300"
  data-lenis-prevent
  (click)="dismissible ? closeModal() : null"
>
  <!-- Modal container -->
  <div
    class="w-full min-w-0 rounded-xl shadow-xl overflow-hidden relative transition-all duration-300 mx-auto transform sm:scale-100 scale-[0.98] max-h-[90vh] overflow-y-auto bg-gray-100 dark:bg-black dark:border dark:border-gray-700"
    [ngClass]="sizeClass"
    (click)="modalClick($event)"
  >
    <!-- Close button (only show if dismissible) -->
    <button
      *ngIf="dismissible"
      class="absolute top-4 right-4 text-gray-600 hover:text-gray-800 dark:text-gray-400 dark:hover:text-gray-200 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 dark:focus:ring-offset-gray-800 p-1 rounded-full z-10"
      aria-label="Close modal"
      (click)="closeModal()"
    >
      <svg
        class="w-6 h-6 sm:w-5 sm:h-5"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2.5"
          d="M6 18L18 6M6 6l12 12"
        ></path>
      </svg>
    </button>

    <!-- Modal content - projected from the parent component -->
    <div [class.pt-12]="!noContentPadding" [class.px-5]="!noContentPadding" [class.pb-5]="!noContentPadding" [class.sm:p-8]="!noContentPadding">
      <ng-content></ng-content>
    </div>
  </div>
</div>
